<template>
  <div>
    <el-card class="box-card">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>软件列表</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>

    <el-card class="content">
      <div class="navbtn">
        <el-card class="button-content">
        <el-button type="primary" size="small" icon="el-icon-refresh" circle @click="refresh" :loading="state"></el-button>
        </el-card>
      </div>
      <el-table :data="SoftData" border style="width: 100%" stripe>
        <el-table-column prop="softName" label="代理软件" ></el-table-column>
        <el-table-column prop="integral" label="积分余额" ></el-table-column>
        <el-table-column prop="createDate" label="开始时间"></el-table-column>
        <el-table-column prop="address" label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="extract(scope.row)">提 卡</el-button>
            <el-button @click="unbinding(scope.row)" size="mini" type="danger">解 绑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!-- 提卡dialog -->
    <el-dialog title="提 卡" :close-on-click-modal="false" :visible.sync="extractDialogVisible" :width="extractDialogWith" @close="closeExtractDiaLog">
      <el-form ref="extractFromRef" :model="extractFrom" label-width="80px" :rules="extractFromRules" class="edit-form" size="small">
        
        <el-form-item label="所属软件" prop="softName" >
          <el-select v-model="extractFrom.softName" :disabled="true" >
            <el-option :label="extractFrom.softName" :value="extractFrom.softName" ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="卡类" prop="type">
          <el-select v-model="extractFrom.type" placeholder="请选择卡类" @change="selectCardType">
            <el-option v-for="item in allCardType" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="生成数量" prop="generateNum">
          <el-input-number v-model="extractFrom.generateNum" controls-position="right" :min="1" :max="100"></el-input-number>
        </el-form-item>

        <el-form-item label="备注" prop="remarks">
          <el-input type="textarea" v-model="extractFrom.remarks" :autosize="{ minRows: 1, maxRows: 4}" placeholder="长度不超过128个字符"></el-input>
        </el-form-item>

        <el-form-item label="" prop="configure" label-width="22px" v-if="extractFrom.customUpperLimit">
          <div class="custom">
            <el-tooltip class="item" effect="dark" placement="top">
              <div slot="content">是否自定义 卡密前缀、顶号登录、多<br/>开上限 参数，它们默认是继承至所属<br/>软件</div>
              <label for="customid" style="margin-left:-18px">自定义<i class="iconfont icon-wenhaoxiao"></i></label>
            </el-tooltip>
            <el-switch id="customid" style="display: block" v-model="extractFrom.custom" active-color="#13ce66" inactive-color="#d2d2d2"></el-switch>
          </div>
        </el-form-item>

        <el-form-item label="多开上限" prop="upperLimit" v-show="extractFrom.custom">
          <el-input-number v-model="extractFrom.customUpperLimitNum" controls-position="right" :min="1" :max="100"></el-input-number>
        </el-form-item>
        <el-tag size="small" type="danger" style="margin-bottom:5px;color:red;float:right;">消耗{{numIntegral}}积分</el-tag>
      </el-form>
      
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="extractBtn" :loading="state">创 建</el-button>
      </span>
    </el-dialog>

    <!-- 解除的dialog -->
    <el-dialog title="确定要解除代理此软件？" :close-on-click-modal="false" :visible.sync="unbindingDialog" :width="unbindingDialogWidth">
      <div slot="title" class="header-title">
        <span class="title-name" style="font-size:20px"><i class="el-icon-warning" style="color: #e6a23c;margin-right:10px"></i>确定要解除代理此软件？<br></span>
      </div>

      <span style="margin-left:30px">{{softName}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="unbindingDialog = false" size="small">取 消</el-button>
        <el-button type="danger" @click="unbindingDialogBtn" size="small" :loading="state">确 定</el-button>
      </span>
    </el-dialog>
  </div>

  
  
</template>

<script>
export default {
  data(){
    return{
      total:0,
      queryInfo: {
        query: "",
        //当前的页数
        pagenum: 1,
        //当前每页显示多少条数据
        pagesize: 10,
        email: this.$store.state.account,
      },
      state:false,
      SoftData:[],
      searchForm:[],
      allSoftName:"",
      searchForm:{},

      extractDialogVisible:false,
      extractFrom:{
        generateNum:1,
        email: this.$store.state.account,
        agentPrice:0,
        customUpperLimit: false,
        customUpperLimitNum:1
      },
      extractFromRules:{
        type:[
          { required: true, message: "请选择卡类!", trigger: ["blur", "change"] },
        ],
        remarks:[
          { min: 0,max: 128,message: "不能超过128个字符!",trigger: ["blur", "change"]},
        ],
      },
      allCardType:[],
      unbindingDialog:false,
      softName:"",
      soft:"",
      extractDialogWith:"500px",
      unbindingDialogWidth:"500px",
      selectIntegral: 0,
      computedIntegral:0
    }
  },
  created(){
    this.$nextTick(()=>{
      if (document.body.clientWidth < 700){
        this.unbindingDialogWidth = '100%'
        this.extractDialogWith = '100%'
      }
    })
    this.getSoftList()
  },
  computed:{
    numIntegral () {
      //生成数量 * 1卡密卡密消耗积分 * 多开数量
      console.log("生成数量:",this.extractFrom.generateNum);
      console.log("单卡积分：", this.selectIntegral);
      console.log("多开数量：",this.extractFrom.customUpperLimitNum);
      return this.extractFrom.generateNum * this.selectIntegral * this.extractFrom.customUpperLimitNum
    }
  },
  methods:{
    async getSoftList(){
      //console.log(this.queryInfo);
      this.state = true
      const result = await this.$http.get("getsoftlist",{
        params:this.queryInfo
      });
      this.state = false
      console.log('result-->',result);
      if(result.data.data.total > 0){
        this.SoftData = result.data.data.data
        this.total = result.data.data.total
        this.allSoftName = this.SoftData.map(element => {
          return element.softName
        })
      }else{
        this.SoftData = []
        this.total = 0
        this.allSoftName = this.SoftData.map(element => {
          return element.softName
        })
      }
    },
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.queryInfo.pagesize = val
      this.getSoftList()
    },
    // 监听 页码值 改变的事件
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.queryInfo.pagenum = val
      this.getSoftList()
    },
    refresh(){
      this.getSoftList()
    },
    //提取卡密
    async extract(index){
      console.log("提卡index:",index);
      this.selectIntegral = 0
      //this.extractFrom.cardName = ""
      this.extractFrom.softName = index.softName+' - '+`[ 积分余额:${index.integral} ]`
      this.extractDialogVisible = true
      this.queryInfo.appKey = index.appKey
      this.extractFrom.appKey = index.appKey
      const result = await this.$http.get("getcardtype",{
        params:this.queryInfo
      });
      console.log("提 卡：", result);
      console.log("提 卡1：", result.data.data);
      this.extractFrom.cardType = result.data.data
      this.allCardType = result.data.data.map(element => {
        return element.cardName + ' - ' + `[ 消耗:${element.agentPrice}积分/卡 ]`
      })
      this.extractFrom.customUpperLimit = index.customUpperLimit
      console.log("extractFrom.customUpperLimit:", this.extractFrom.customUpperLimit);
    },
    selectCardType(val){
      // console.log("val:",val);
      let start = val.indexOf("[")
      let end = val.indexOf("]")
      let str = val.slice(start, end + 1)
      console.log("str=",str);
      this.selectIntegral = str.replace(/[^\d]/g, "");
      // console.log("this.selectIntegral:",this.selectIntegral);
    },
    unbinding(index){
      console.log(index);
      this.softName = index.softName
      this.unbindingDialog = true
      this.soft = index
    },
    closeExtractDiaLog(){
      this.extractFrom.cardName = ""
      this.$refs.extractFromRef.resetFields()
      this.extractFrom.customUpperLimitNum = 1;
      this.extractFrom.custom = false;
      console.log("dialog关闭事件");
    },
    extractBtn(){
      this.$refs.extractFromRef.validate(async valid => {
        if(!valid) return
        console.log("this.extractFrom:",this.extractFrom);
        delete this.extractFrom.cardType
        delete this.extractFrom.email
        this.state = true
        const result = await this.$http.post('createAgentCardPassword',this.extractFrom)
        //console.log(result);
        this.state = false
        if(result.data.meta.status !== 200){
          this.$notify.error({title: '错误',message:result.data.meta.msg});
          return
        }
        this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
        this.extractDialogVisible = false
        this.getSoftList()
        this.$refs.extractFromRef.resetFields()
      })
    },
    async unbindingDialogBtn(){
      this.soft.email = this.$store.state.account,
      this.state = true
      const result = await this.$http.post('delrelation',this.soft)
      console.log(result);
      this.state = false
      if(result.data.meta.status !== 200){
        this.$notify.error({title: '错误',message:result.data.meta.msg});
        return
      }
      this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
      this.unbindingDialog = false
      this.getSoftList()
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  margin: 5px;
  .el-pagination {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
  }
  .el-table{
    margin-top: 20px;
  }
}
.el-form .el-select{
  width: 80%;
}

.custom{
  display: flex;
  justify-content: flex-start;
  .el-switch{
    margin-top: 6px;
  }
}
</style>